module.exports = __webpack_public_path__ + "img/thermometer-03.d311ab87.svg";